import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';

import { setURI, save, setErrors } from './actions';
import { setMode as setGlobalMode, resetMode, MODE_CONCENTRATE, request } from '../containers/actions';
import tinyMCEConfig from '../utilities/tinymce_config';
import Content from './content';
import { Button } from 'rmwc';
import { SSO_login } from '../utilities/requests';
import { request_sso_login } from '../components/sso_callback/sso';

export default class ContentManager extends React.Component {
    static contextTypes = {
        user: PropTypes.object,
        pending: PropTypes.number,
    }

    constructor(props, context) {
        super(props, context);
        
        const currentUri = props.uri || '';
        
        const redirectMap = {
    '/azmuns': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/18/0/introduction/': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/2/0/introduction/': 'https://www.mhelli.com/exam/',
    '/azmuns': 'https://www.mhelli.com/exam/',
    '/azmoon/': 'https://www.mhelli.com/exam/',
    '/books/': 'https://www.mhelli.com/book/',
    '/examination-catalogue/2/0/introduction/': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/23/0/introduction/': 'https://www.mhelli.com/exam/',
    '/best': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/5/0/introduction/': 'https://www.mhelli.com/exam/',
    '/ContactUs': 'https://www.mhelli.com/contact-us/',
    '/examination-catalogue/4/0/introduction/': 'https://www.mhelli.com/exam/',
    '/faq-azmoon': 'https://www.mhelli.com/faq/',
    '/examination-catalogue/8/0/introduction/': 'https://www.mhelli.com/exam/',
    '/AboutUs': 'https://www.mhelli.com/about-us/',
    '/72': 'https://www.mhelli.com/exam/',
    '/livebook': 'https://www.mhelli.com/book/',
    '/hamayesh_esfand403_8_1': 'https://www.mhelli.com/exam/',
    '/faq-book': 'https://www.mhelli.com/faq/',
    '/کلاس‌ها/': 'https://www.mhelli.com/class/',
    '/books/preview/': 'https://www.mhelli.com/book/',
    '/examination-catalogue/5/0/introduction/': 'https://www.mhelli.com/exam/',
    '/hamayesh_tahlil_9hafte': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/10/0/introduction/': 'https://www.mhelli.com/exam/',
    '/land/': 'https://www.mhelli.com/',
    '/examination-catalogue/8/0/introduction/': 'https://www.mhelli.com/exam/',
    '/hamayesh-19-6': 'https://www.mhelli.com/exam/',
    '/chalesh_6_8': 'https://www.mhelli.com/exam/',
    '/faq': 'https://www.mhelli.com/faq/',
    '/sabtnam-9-19': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/9/0/introduction/': 'https://www.mhelli.com/exam/',
    '/maryam_mirzakhani': 'https://www.mhelli.com/exam/',
    '/about-us/': 'https://www.mhelli.com/about-us/',
    '/examination-catalogue/4/0/introduction/': 'https://www.mhelli.com/exam/',
    '/regions/': 'https://www.mhelli.com/exam/',
    '/hamayesh': 'https://www.mhelli.com/exam/',
    '/hamayesh-19-9': 'https://www.mhelli.com/exam/',
    '/akhbareazmoon': 'https://www.mhelli.com/exam/',
    '/planning': 'https://www.mhelli.com/exam/',
    '/books': 'https://www.mhelli.com/book/',
    '/news': 'https://www.mhelli.com/exam/',
    '/chalesh_7_9': 'https://www.mhelli.com/exam/',
    '/chalesh_6_9': 'https://www.mhelli.com/exam/',
    '/chalesh_2': 'https://www.mhelli.com/exam/',
    '/chalesh_7_8': 'https://www.mhelli.com/exam/',
    '/chaesh_3_9': 'https://www.mhelli.com/exam/',
    '/chalesh_11_9': 'https://www.mhelli.com/exam/',
    '/sabtnam-6-19': 'https://www.mhelli.com/exam/',
    '/chalesh_12_8': 'https://www.mhelli.com/exam/',
    '/chalesh_10_8': 'https://www.mhelli.com/exam/',
    '/sabtnam-۱۹-۶': 'https://www.mhelli.com/exam/',
    '/hamayesh_esfand403_8_2': 'https://www.mhelli.com/exam/',
    '/chalesh_4_9': 'https://www.mhelli.com/exam/',
    '/chalesh_9_8': 'https://www.mhelli.com/exam/',
    '/Empowerment_Academy': 'https://www.mhelli.com/exam/',
    '/faq': 'https://www.mhelli.com/faq/',
    '/chalesh_8_9': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/23/0/introduction/': 'https://www.mhelli.com/exam/',
    '/book/40/0/sample_pages/': 'https://www.mhelli.com/book/',
    '/marathon': 'https://www.mhelli.com/exam/',
    '/books/preview/': 'https://www.mhelli.com/book/',
    '/chalesh_13_9': 'https://www.mhelli.com/exam/',
    '/chalesh_10_9': 'https://www.mhelli.com/exam/',
    '/chalesh_8_8': 'https://www.mhelli.com/exam/',
    '/chalesh_12_9': 'https://www.mhelli.com/exam/',
    '/learning': 'https://www.mhelli.com/exam/',
    '/best': 'https://www.mhelli.com/exam/',
    '/books/preview/': 'https://www.mhelli.com/book/',
    '/books/katalog': 'https://www.mhelli.com/book/',
    '/sabtnam_6_19': 'https://www.mhelli.com/exam/',
    '/problem_solving': 'https://www.mhelli.com/exam/',
    '/chalesh_9_9': 'https://www.mhelli.com/exam/',
    '/livebook': 'https://www.mhelli.com/book/',
    '/tavanmandy_6': 'https://www.mhelli.com/exam/',
    '/chalesh_13_8': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/17/0/introduction/': 'https://www.mhelli.com/exam/',
    // '/books/preview/': 'https://www.mhelli.com/book/',
    '/week_1': 'https://www.mhelli.com/exam/',
    '/sabtnam': 'https://www.mhelli.com/exam/',
    '/Forest': 'https://www.mhelli.com/exam/',
    '/21_Ramadan': 'https://www.mhelli.com/exam/',
    '/WEEK-3': 'https://www.mhelli.com/exam/',
    '/learning_style': 'https://www.mhelli.com/exam/',
    '/study': 'https://www.mhelli.com/exam/',
    '/Negative_self_talk': 'https://www.mhelli.com/exam/',
    '/books': 'https://www.mhelli.com/book/',
    '/sabtnam-۶-۱۹': 'https://www.mhelli.com/exam/',
    '/sabtnam-۹-۱۹': 'https://www.mhelli.com/exam/',
    '/sabtnam-٩-١٩': 'https://www.mhelli.com/exam/',
    '/faq-azmoon': 'https://www.mhelli.com/faq/',
    '/sabtnam_9_19': 'https://www.mhelli.com/exam/',
        };
        
        for (const [path, redirectUrl] of Object.entries(redirectMap)) {
            if (currentUri === path || currentUri.startsWith(path + '/') || currentUri.includes(path)) {
                if (redirectUrl.startsWith('http')) {
                    // ریدایرکت خارجی
                    window.location.href = redirectUrl;
                } else {
                    // ریدایرکت داخلی با react-router
                    if (props.dispatch) {
                        props.dispatch(push(redirectUrl));
                    } else {
                        window.location.href = redirectUrl;
                    }
                }
                // برگرداندن null برای جلوگیری از ادامه رندر
                this.shouldRedirect = true;
                return;
            }
        }
        
        // بررسی برای صفحه ساخته نشده (حتی قبل از mount)
        if (props.content && !props.content.id && !props.content.published) {
            if (context.user && context.user.id) {
                // ریدایرکت فوری به صفحه پیش‌فرض
                // if (props.dispatch) {
                //     props.dispatch(push('/dashboard'));
                // } else {
                //     window.location.href = '/dashboard';
                // }
                this.shouldRedirect = true;
                return;
            }
        }
        
        this.state = {
            content: props.content.content,
            title: props.content.title,
            uri: props.content.uri,
            published: props.content.published,
            user_edit_level: 1
        };
        this.shouldRedirect = false;
    }

    componentDidMount() {
        // اگر قبلاً ریدایرکت شده، هیچ کاری نکن
        if (this.shouldRedirect) return;
        
        // فقط اگر ریدایرکت نشده، dispatch کن
        this.props.dispatch(setURI(this.props.uri, this.props.elementId));
    }

    componentWillReceiveProps(nextProps, nextState) {
        // اگر قبلاً ریدایرکت شده، هیچ کاری نکن
        if (this.shouldRedirect) return;
        
        // بررسی ریدایرکت در props جدید
             const redirectMap = {
    '/azmuns': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/18/0/introduction/': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/2/0/introduction/': 'https://www.mhelli.com/exam/',
    '/azmuns': 'https://www.mhelli.com/exam/',
    '/azmoon/': 'https://www.mhelli.com/exam/',
    '/books/': 'https://www.mhelli.com/book/',
    '/examination-catalogue/2/0/introduction/': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/23/0/introduction/': 'https://www.mhelli.com/exam/',
    '/best': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/5/0/introduction/': 'https://www.mhelli.com/exam/',
    '/ContactUs': 'https://www.mhelli.com/contact-us/',
    '/examination-catalogue/4/0/introduction/': 'https://www.mhelli.com/exam/',
    '/faq-azmoon': 'https://www.mhelli.com/faq/',
    '/examination-catalogue/8/0/introduction/': 'https://www.mhelli.com/exam/',
    '/AboutUs': 'https://www.mhelli.com/about-us/',
    '/72': 'https://www.mhelli.com/exam/',
    '/livebook': 'https://www.mhelli.com/book/',
    '/hamayesh_esfand403_8_1': 'https://www.mhelli.com/exam/',
    '/faq-book': 'https://www.mhelli.com/faq/',
    '/کلاس‌ها/': 'https://www.mhelli.com/class/',
    '/books/preview/': 'https://www.mhelli.com/book/',
    '/examination-catalogue/5/0/introduction/': 'https://www.mhelli.com/exam/',
    '/hamayesh_tahlil_9hafte': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/10/0/introduction/': 'https://www.mhelli.com/exam/',
    '/land/': 'https://www.mhelli.com/',
    '/examination-catalogue/8/0/introduction/': 'https://www.mhelli.com/exam/',
    '/hamayesh-19-6': 'https://www.mhelli.com/exam/',
    '/chalesh_6_8': 'https://www.mhelli.com/exam/',
    '/faq': 'https://www.mhelli.com/faq/',
    '/sabtnam-9-19': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/9/0/introduction/': 'https://www.mhelli.com/exam/',
    '/maryam_mirzakhani': 'https://www.mhelli.com/exam/',
    '/about-us/': 'https://www.mhelli.com/about-us/',
    '/examination-catalogue/4/0/introduction/': 'https://www.mhelli.com/exam/',
    '/regions/': 'https://www.mhelli.com/exam/',
    '/hamayesh': 'https://www.mhelli.com/exam/',
    '/hamayesh-19-9': 'https://www.mhelli.com/exam/',
    '/akhbareazmoon': 'https://www.mhelli.com/exam/',
    '/planning': 'https://www.mhelli.com/exam/',
    '/books': 'https://www.mhelli.com/book/',
    '/news': 'https://www.mhelli.com/exam/',
    '/chalesh_7_9': 'https://www.mhelli.com/exam/',
    '/chalesh_6_9': 'https://www.mhelli.com/exam/',
    '/chalesh_2': 'https://www.mhelli.com/exam/',
    '/chalesh_7_8': 'https://www.mhelli.com/exam/',
    '/chaesh_3_9': 'https://www.mhelli.com/exam/',
    '/chalesh_11_9': 'https://www.mhelli.com/exam/',
    '/sabtnam-6-19': 'https://www.mhelli.com/exam/',
    '/chalesh_12_8': 'https://www.mhelli.com/exam/',
    '/chalesh_10_8': 'https://www.mhelli.com/exam/',
    '/sabtnam-۱۹-۶': 'https://www.mhelli.com/exam/',
    '/hamayesh_esfand403_8_2': 'https://www.mhelli.com/exam/',
    '/chalesh_4_9': 'https://www.mhelli.com/exam/',
    '/chalesh_9_8': 'https://www.mhelli.com/exam/',
    '/Empowerment_Academy': 'https://www.mhelli.com/exam/',
    '/faq': 'https://www.mhelli.com/faq/',
    '/chalesh_8_9': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/23/0/introduction/': 'https://www.mhelli.com/exam/',
    '/book/40/0/sample_pages/': 'https://www.mhelli.com/book/',
    '/marathon': 'https://www.mhelli.com/exam/',
    '/books/preview/': 'https://www.mhelli.com/book/',
    '/chalesh_13_9': 'https://www.mhelli.com/exam/',
    '/chalesh_10_9': 'https://www.mhelli.com/exam/',
    '/chalesh_8_8': 'https://www.mhelli.com/exam/',
    '/chalesh_12_9': 'https://www.mhelli.com/exam/',
    '/learning': 'https://www.mhelli.com/exam/',
    '/best': 'https://www.mhelli.com/exam/',
    '/books/preview/': 'https://www.mhelli.com/book/',
    '/books/katalog': 'https://www.mhelli.com/book/',
    '/sabtnam_6_19': 'https://www.mhelli.com/exam/',
    '/problem_solving': 'https://www.mhelli.com/exam/',
    '/chalesh_9_9': 'https://www.mhelli.com/exam/',
    '/livebook': 'https://www.mhelli.com/book/',
    '/tavanmandy_6': 'https://www.mhelli.com/exam/',
    '/chalesh_13_8': 'https://www.mhelli.com/exam/',
    '/examination-catalogue/17/0/introduction/': 'https://www.mhelli.com/exam/',
    // '/books/preview/': 'https://www.mhelli.com/book/',
    '/week_1': 'https://www.mhelli.com/exam/',
    '/sabtnam': 'https://www.mhelli.com/exam/',
    '/Forest': 'https://www.mhelli.com/exam/',
    '/21_Ramadan': 'https://www.mhelli.com/exam/',
    '/WEEK-3': 'https://www.mhelli.com/exam/',
    '/learning_style': 'https://www.mhelli.com/exam/',
    '/study': 'https://www.mhelli.com/exam/',
    '/Negative_self_talk': 'https://www.mhelli.com/exam/',
    '/books': 'https://www.mhelli.com/book/',
    '/sabtnam-۶-۱۹': 'https://www.mhelli.com/exam/',
    '/sabtnam-۹-۱۹': 'https://www.mhelli.com/exam/',
    '/sabtnam-٩-١٩': 'https://www.mhelli.com/exam/',
    '/faq-azmoon': 'https://www.mhelli.com/faq/',
    '/sabtnam_9_19': 'https://www.mhelli.com/exam/',
        };
        
        for (const [path, redirectUrl] of Object.entries(redirectMap)) {
            if (nextProps.uri === path || (nextProps.uri && nextProps.uri.startsWith(path + '/'))) {
                if (redirectUrl.startsWith('http')) {
                    window.location.href = redirectUrl;
                } else {
                    this.props.dispatch(push(redirectUrl));
                }
                this.shouldRedirect = true;
                return;
            }
        }
        
        if (nextProps.uri !== this.props.uri)
            this.props.dispatch(setURI(nextProps.uri, nextProps.elementId));
        if (nextProps.content.content !== this.props.content.content)
            this.setState({ content: nextProps.content.content });
        if (nextProps.content.title !== this.props.content.title)
            this.setState({ title: nextProps.content.title });
        if (nextProps.content.uri !== this.props.content.uri)
            this.setState({ uri: nextProps.content.uri });
        if (nextProps.content.published !== this.props.content.published)
            this.setState({ published: nextProps.content.published });
    }

    async save() {
        if (this.shouldRedirect) return;
        
        try {
            await this.props.dispatch(save(
                {
                    id: this.props.content.id,
                    title: this.state.title,
                    uri: this.state.uri,
                    content: this.state.content,
                    published: this.state.published,
                    edit_level: this.state.user_edit_level
                },
                this.props.elementId,
            ));
        }
        catch (error) {
            this.props.dispatch(setErrors(error, this.props.elementId));
        }
    }

    render() {
        // اگر باید ریدایرکت شود، هیچ چیزی رندر نکن
        if (this.shouldRedirect) {
            return null;
        }
        
        return <div style={{
            marginTop: '.5em',
            margin: 'auto',
            transform: 'scale(' + Math.min(1, window.innerWidth / 1000) + ')',
            transformOrigin: 'top right 0px',
            display: 'block',
            width: window.innerWidth / Math.min(1, window.innerWidth / 1000),
            maxWidth: '1100px'
        }}>
            {this.context.user.hasPerm('content_manager.create') || this.props.content.published
                ? <Content
                    url={window.location.pathname}
                    content={this.props.content.content}
                    title={this.state.title || '-'}
                    uri={this.state.uri}
                    published={this.props.content.published}
                    readonly={this?.context?.user?.hasPerm('content_manager.create') || this?.context?.user?.is_superuser ? false : true}
                    errors={this.props.errors}
                    actions={[{ label: window.gettext('Save'), action: this.save.bind(this), default: true }]}
                    titleLabel={window.gettext('Page Title')}
                    preview
                    tinymceConfig={{
                        ...tinyMCEConfig,
                        toolbar: [
                            ...tinyMCEConfig.toolbar.slice(0, -1),
                            tinyMCEConfig.toolbar.slice(-1)[0] + ' | map toggle_position toggle_size line effects store_item',
                        ],
                    }}
                    onFocusin={() => {
                        this.props.dispatch(setGlobalMode(MODE_CONCENTRATE));
                    }}
                    onFocusout={() => {
                        this.props.dispatch(resetMode());
                    }}
                    onChange={content => {
                        this.setState({ content });
                    }}
                    onTitleChange={title => {
                        this.setState({ title });
                    }}
                    onURIChange={uri => {
                        this.setState({ uri });
                    }}
                    onPublishedChange={published => {
                        this.setState({ published });
                    }}
                    onLinkClicked={event => {
                        let node = event.target;
                        while (node && !(node instanceof HTMLAnchorElement)) {
                            node = node.parentNode;
                        }
                        if (!node)
                            return;
                        let href = node.href || node.xlinkHref;
                        if (!href)
                            return;
                        if (href.baseVal)
                            href = href.baseVal;
                        let base = `${window.location.protocol}//${window.location.hostname}`;
                        if (window.location.port)
                            base += `:${window.location.port}`;
                        if (href.startsWith(base) || !_.includes(href, '://')) {
                            event.preventDefault();
                            this.props.dispatch(push(href.replace(new RegExp('^' + base), '')));
                        }
                    }}
                    onPermissionChange={user_edit_level => {
                        this.setState({ user_edit_level })
                    }}
                />
                : this.context.pending
                    ? null
                    : this.context.user.id ? <div style={{ fontSize: '2em', textAlign: 'center' }}>
                        <br />
                        <br />
                        <span style={{ fontSize: '3em' }}>
                            404
                        </span>
                        <br />
                        {window.gettext('Page not found!')}
                    </div> : <div className='primision-box' >
                        <p>
                            <br />
                            شما دسترسی لازم برای مشاهده این صفحه را ندارید
                            <br />
                            لطفا ابتدا به حساب خود وارد شوید.
                            <br />
                        </p>
                        <Button style={{ fontSize: '1.4rem', borderRadius: '5px', border: '1px solid' }} onClick={() => 
                            SSO_login ? request_sso_login() : this.props.router.push('/?dialog=login')
                        }>{window.gettext("login")}</Button>
                    </div>
            }
        </div>;
    }
};